import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import { swal, typeChecker } from "../../../utils/methods";
import { _post } from "../../../utils/network";

import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb.component';
import FormField from "../../../components/Form/FormField/FormField.component";
import LoadingButton from '../../../components/LoadingButton/LoadingButton.component';

const BannersCreate = ({ componentType='create' }) => {
	const { t } = useTranslation();
	const { id } = useParams();
	const navigate = useNavigate();
	const breadcrumbItems = [
		{ title: t('dashboard'), link: '/dashboard' },
		{ title: t('banners'), link: '/banners-list' },
		{ title: t(componentType) }
	];
	const confirmSwal = statements => {
		swal(() => statements(), {
			text: t('are_you_sure_to_do_this'),
			confirmButtonText: t('yes'),
			cancelButtonText: t('no')
		});
	};

	const [createButtonIsLoading, setCreateButtonIsLoading] = useState(false);
	const createBanner = async (event) => {
		event.preventDefault();
		if(createButtonIsLoading)
			return 0;
		let type = event.target.bannerType.value;
		let is_active = event.target.bannerIsActive.checked ? 1 : 0;
		let image = document.querySelector('#bannerImage-upload-list img')?.getAttribute('src').trim();
		if(!typeChecker(image, 'image'))
			return toast.warn(t('image') + ' ' + t('cant_be_empty'));
		let darkImage = document.querySelector('#bannerDarkImage-upload-list img')?.getAttribute('src').trim();
		if(!typeChecker(darkImage, 'image'))
			return toast.warn(t('dark_mode_image') + ' ' + t('cant_be_empty'));
		let link = event.target.bannerLink.value.trim();
		let body = {
			banner_id: id,
			banner_image: image,
			banner_link: link,
			banner_type: type,
			other_information: {
				dark_image: darkImage
			},
			is_active
		};
		confirmSwal(async () => {
			setCreateButtonIsLoading(true);
			let response = await _post('/banners/admin/' + componentType, body);
			setCreateButtonIsLoading(false);
			switch(response.code){
				case 200:
					toast.success(response[t('api_message')]);
					if(componentType === 'create')
						event.target.reset();
					break;
				default:
					toast.error(response[t('api_message')]);
			}
		});
	};

	const [deleteButtonIsLoading, setDeleteButtonIsLoading] = useState(false);
	const deleteBanner = async () => {
		if(deleteButtonIsLoading)
			return 0;
		let body = {
			banner_id: id
		};
		confirmSwal(async () => {
			setDeleteButtonIsLoading(true); 
			let response = await _post('/banners/admin/delete', body);
			setDeleteButtonIsLoading(false);
			switch(response.code){
				case 200:
					navigate("/banners-list");
					break;
				default:
					toast.error(response[t('api_message')]);
			}
		});
	};

	const [banner, setBanner] = useState({});
	const getBanner = async () => {
		let body = {
			banner_id: id
		};
		let response = await _post('/banners/admin/getOne', body);
		switch(response.code){
			case 200:
				setBanner(response.data.banner);
				break;
			default:
				toast.error(response[t('api_message')]);
		}
	};

	const bannerTypesList = [
		{ key: t('home_page'), value: 1 },
		{ key: t('notifications'), value: 2 },
		{ key: t('portal'), value: 3 },
		{ key: t('marketers_club'), value: 4 },
		{ key: t('analysers_club'), value: 5 },
		{ key: t('consultation'), value: 6 },
		{ key: t('shop'), value: 7 },
		{ key: t('contests'), value: 8 }
	];

	useEffect(() => {
		if(componentType === 'edit')
			getBanner();
	}, []);

	return (
		<>
			<Breadcrumb items={breadcrumbItems} />
			<div className="card mb-3">
				<div className="card-header">
					<h5 className="mb-0">{t(componentType)} {t('banner')}</h5>
				</div>
				<div className="card-body bg-light">
					<form onSubmit={createBanner}>
						<div className="row gx-2">
							<FormField type="select" fieldKey="bannerType" title={t('type')} value={banner?.banner_type} required selectItems={bannerTypesList} />
							<FormField type="toggle" fieldKey="bannerIsActive" title={t('active')} value={banner?.is_active} required />
							<FormField type="image" fieldKey="bannerImage" title={t('image')} value={banner?.banner_image} required tip="200*200" fileMaxSize={2} />
							<FormField type="image" fieldKey="bannerDarkImage" title={t('dark_mode_image')} value={banner?.other_information?.dark_image} required tip="200*200" fileMaxSize={2} />
							<FormField fieldKey="bannerLink" title={t('link')} value={banner?.banner_link} ltr />
						</div>
						<div>
							{componentType === 'create' ?
								<LoadingButton className="btn btn-primary d-inline-block mt-3 me-2" type="submit" name="create" isLoading={createButtonIsLoading}>
									<i className="fa fa-save"></i> {t('create')}
								</LoadingButton>
							:
								<>
									<LoadingButton className="btn btn-primary d-inline-block mt-3 me-2" type="submit" name="edit" isLoading={createButtonIsLoading}>
										<i className="fa fa-save"></i> {t('update')}
									</LoadingButton>
									<LoadingButton className="btn btn-danger d-inline-block mt-3" onClick={deleteBanner} type="button" name="delete" isLoading={deleteButtonIsLoading}>
										<i className="fa fa-trash"></i> {t('delete')}
									</LoadingButton>
								</>
							}
						</div>
					</form>
				</div>
			</div>
		</>
	);
};

export default BannersCreate;
